// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/umweltpakt-bayern-2-2-2-2-4/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const umweltpaktBayern22224DE: PageEntry = {
  id: "post.umweltpakt-bayern-2-2-2-2-4",
  locale: "de",
  slug: "umweltpakt-bayern-2-2-2-2-4",
  seo: {
    title: "\"Raus aus den Federn - ab auf's Rad!\" | Dietz GmbH",
    description: "\"Raus aus den Federn - ab auf's Rad!\"",
  },
  type: "post",
  h1: "\"Raus aus den Federn - ab auf's Rad!\"",
  blocks: [
    { kind: "heading", level: 2, text: "„Raus aus den Federn – ab auf’s Rad!“" }
  ],
};
